export default {
    all: { method: 'GET', url: 'empresa/all' },
    active: { method: 'GET', url: 'empresa/active' },
    get: { method: 'GET', url: 'empresa/get{/id}' },
    create: { method: 'POST', url: 'empresa' },
    update: { method: 'PUT', url: 'empresa' },
    inactive: { method: 'DELETE', url: 'empresa{/id}' },
};